import Parse from 'parse';

import { ILicenseInfo } from '../license/i-license-info';

export class Organization extends Parse.Object {
  static className = 'Organization';

  constructor({ name, license }: { name?: string; license?: Partial<ILicenseInfo> } = {}) {
    super(Organization.className);
    this.name = name;
    this.set('license', license);
  }

  get name(): string {
    return this.get('name') ?? '';
  }
  set name(name: string) {
    this.set('name', name);
  }

  get logo(): Parse.File {
    return this.get('logo');
  }
  set logo(logo: Parse.File) {
    this.set('logo', logo);
  }

  get logoUrl(): string {
    return this.logo?.url?.();
  }

  get usedStorage(): number {
    return this.get('usedStorage');
  }
  set usedStorage(value: number) {
    this.set('usedStorage', value);
  }

  get license(): ILicenseInfo {
    return this.get('license') || {};
  }

  set license(license: ILicenseInfo) {
    this.set('license', license);
  }

  get environment(): { [key: string]: unknown } {
    return this.get('environment') || {};
  }

  get language(): string {
    return this.license?.language || 'en';
  }
}
